import Tag from "components/newShared/Tag";
import { HiOutlinePhone } from "react-icons/hi";
import { Navbar } from "components/navbar/Navbar";
import FooterSection from "components/newShared/FooterSection";
import ContactInfo from "./ContactInfo";
import ContactForm from "./ContactForm";
import { FaqSection } from "components";

const ContactUs = () => {
  return (
    <div id="contact" className="w-full font-SatoshiRegular">
      <div className="bg-ashShade-17">
        <div className="py-8 md:py-16 xl:py-20 px-5 md:px-16 lg:px-16">
          <div className="flex flex-col lg:flex-row justify-between referral-container gap-10 lg:gap-0 lg:items-center xl:items-start">
            <div className="flex flex-col gap-10 xl:gap-12 w-full lg:w-5/12">
              <div>
                <Tag
                  title="Contact us"
                  icon={<HiOutlinePhone size={16} />}
                  className="border-blueShades-6 text-blueShades-6"
                />
                <div className="text-bblack-5 pt-3 flex flex-col gap-2">
                  <h3 className="font-SatoshiBold text-2xl lg:text-5xl text-center lg:text-left">
                    Have any questions? Contact us{" "}
                  </h3>
                  <p className="leading-6 font-medium lg:w-[35ch]">
                    Reach out to us for inquires, support, or partnership
                    opportunities. We're here to assist you!
                  </p>
                </div>
              </div>
              <ContactInfo />
            </div>
            <ContactForm />
          </div>
        </div>
      </div>
      <FaqSection bgColor={"!bg-white"} />
    </div>
  );
};

export default ContactUs;
